import React from "react";

function Footer() {
  return (
    <div className="footer__layout">
      <h4>
        <b className="hover-underline-animation">Email</b>:
        contact@dsb-management.com
      </h4>
    </div>
  );
}

export default Footer;
